module.exports = __webpack_public_path__ + "static/media/96.87091ec6.gif";